import { render, staticRenderFns } from "./Labos1point5Charter.vue?vue&type=template&id=0c521416&scoped=true"
import script from "./Labos1point5Charter.vue?vue&type=script&lang=js"
export * from "./Labos1point5Charter.vue?vue&type=script&lang=js"
import style0 from "./Labos1point5Charter.vue?vue&type=style&index=0&id=0c521416&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c521416",
  null
  
)

export default component.exports